/** Etiqueta roja en tarjetas: «No disponible hasta …» + motivo en segunda línea. */
export function esNoDisponibleTemporal(p) {
  if (!p?.disponible_desde) return false;
  const d = new Date(p.disponible_desde);
  return !Number.isNaN(d.getTime()) && d > new Date();
}

/** Offset vertical (px) para apilar otras badges debajo. */
export function topDebajoBadgeNoDisponible(p) {
  if (!esNoDisponibleTemporal(p)) return 8;
  const motivo = String(p.motivo_no_disponible || "").trim();
  return motivo ? 50 : 34;
}

export default function BadgeNoDisponible({ disponibleDesde, motivo, style = {} }) {
  if (!disponibleDesde || new Date(disponibleDesde) <= new Date()) return null;
  const fecha = new Date(disponibleDesde).toLocaleDateString("es-ES", {
    day: "numeric",
    month: "short",
  });
  const motivoTxt = String(motivo || "").trim();

  return (
    <div
      style={{
        position: "absolute",
        top: 8,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 6,
        padding: motivoTxt ? "4px 10px" : "3px 10px",
        borderRadius: 6,
        fontSize: 10,
        fontWeight: 700,
        color: "#fff",
        letterSpacing: "0.02em",
        background: "linear-gradient(135deg, #ef4444, #dc2626)",
        boxShadow: "0 2px 8px rgba(239,68,68,0.4)",
        textAlign: "center",
        lineHeight: 1.25,
        maxWidth: "92%",
        ...style,
      }}
    >
      <div style={{ whiteSpace: "nowrap" }}>No disponible hasta {fecha}</div>
      {motivoTxt ? (
        <div
          style={{
            fontSize: 9,
            fontWeight: 600,
            marginTop: 2,
            opacity: 0.95,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          title={motivoTxt}
        >
          {motivoTxt}
        </div>
      ) : null}
    </div>
  );
}
